import _isNil from 'lodash/isNil';

import DimensionUtils from './dimensions';

export class PopupUtils {
  static getSafePosition(
    triggerRef,
    {
      position = 'bottom center',
      leftPosition = 'bottom left',
      rightPosition = 'bottom right',
    } = {},
  ) {
    if (_isNil(triggerRef)) {
      return position;
    }

    const { tooCloseToLeft, tooCloseToRight } =
      DimensionUtils.getRelativeDistanceToWindowBorders(triggerRef);

    if (tooCloseToLeft) {
      return leftPosition;
    }
    if (tooCloseToRight) {
      return rightPosition;
    }
    return position;
  }
}
